import { UIComponent } from '@/components/core/components';
import clsx from 'clsx';
import { msg } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Image, Scrollable } from '@/components/core';
import * as styles from './ratings.styles';
import Subtitle from '../subtitle';
import Rating from './_components/rating';
import RatingCard from './_components/rating/rating-card/rating-card';

const ratings = [
  {
    user: 'Roo Retambay',
    date: new Date('01/09/2024'),
    value: 5,
    message: msg`Super useful, you can find everything! If you are like me, always looking for movie recommendations and never finding anything, so you don’t know what to watch, this app is the best.`,
  },
  {
    user: 'Pilar',
    date: new Date('07/29/2020'),
    value: 5,
    message: msg`Very good app if you like recommending movies, series, music, accessories... as well as if you also like discovering new things thanks to other users’ recommendations. Plus, you can even earn money when you level up by completing a series of challenges, like in a 'game'.`,
  },
  {
    user: 'sonuxy',
    date: new Date('08/16/2024'),
    value: 5,
    message: msg`👍🏼 Very useful app to know honest opinions about anything. Restaurants, places, series, movies...`,
  },
];

const Ratings: UIComponent = ({ className }) => {
  return (
    <section className={clsx(styles.root, className)}>
      <Subtitle>
        <Trans>Ratings and Reviews</Trans>
      </Subtitle>
      <div className={styles.content}>
        <div className={styles.stores}>
          <Rating rating={{ value: 4.5, total: 153000 }}>
            <Image src="/store-android.png" alt="Google store" />
          </Rating>
          <Rating rating={{ value: 4.7, total: 8700 }}>
            <Image src="/store-ios.png" alt="iOS store" />
          </Rating>
        </div>
        <div className={styles.ratings}>
          <Scrollable snap>
            <div className={styles.scrollContent}>
              {ratings.map((rating) => {
                return <RatingCard key={rating.user} rating={rating} />;
              })}
            </div>
          </Scrollable>
        </div>
      </div>
    </section>
  );
};

export default Ratings;
